import { render, staticRenderFns } from "./build-specs.vue?vue&type=template&id=d91259f0&scoped=true&"
import script from "./build-specs.vue?vue&type=script&lang=js&"
export * from "./build-specs.vue?vue&type=script&lang=js&"
import style0 from "./build-specs.vue?vue&type=style&index=0&id=d91259f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91259f0",
  null
  
)

export default component.exports